import {asset} from 'imba';
import url from './streamers.jpg';
export default asset({
	url: url,
	type: 'image',
	width: 1511,
	height: 1051,
	toString: function(){ return this.url;}
})